import { useState, useEffect } from 'react';
import { useDashboardStore } from '../../../pages/hooks/useDashboardStore';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { BasicTable, MASK_BOOLEAN_ICON } from '../../../theme/Component/BasicTable';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import { Modal } from '../../../theme/Component/Modal';
import { AdminService } from '../../../../core/services/AdminService';
import { ContractRoleSelect } from '../ContractRoleSelect';
import { SelectorTramites } from '../../../bpm/config/Componentes/SelectorTramites';
import { SelectorClaseTramites } from '../../../bpm/config/Componentes/SelectorClaseTramites';
import { BasicPage } from '../../../theme/Component/BasicPage';
import { _BusinessProcess, _single } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import { JsonFormaterInput } from '../../../theme/Component/JsonFormaterInput';
import { BasicSwitch } from '../../../theme/Component/BasicSwitch';
import { RequestTypeBpmAccount } from './RequestTypeBpmAccount/RequestTypeBpmAccount';

interface initPorcess {
    Obs: string;
    VarName: string;
    VarValue: number;
    JsonProps: string;
    ExternalCode?: string
}

export const RequestTypeBpm = () => {

    const _bProcess = useDataBean(_BusinessProcess)
    const { setLoading } = useDashboardStore();
    const Service = new AdminService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [response, setResponse] = useState<Partial<initPorcess>>({
        JsonProps: "{}",
    })

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalStart, setModalStart] = useState<any>({ name: 'Iniciar Proceso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalUsers, setModalUsers] = useState<any>({ name: 'Usuarios en el Proceso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const idBean = 'IDRequestTypeBpm';

    const head = [
        { title: 'ID', property: idBean, visible: false },
        { title: 'Código', property: 'CodeProcess' },
        { title: 'Rol', property: 'RoleName' },
        { title: 'Trámite', property: 'Name' },
        { title: '¿Es Publico?', property: 'IsPublic', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Propiedades de inicializacion', property: 'InitProps', visible: false },
    ]


    const total = () => {
        updateItem();
    }

    useEffect(() => {
        getLista();
    }, [idBean])


    const setRowBean = (bean: any) => {
        setBean(bean);
    }

    const getLista = () => {
        setLoading(true);
        Service.getRequestTypeBpmCatalogRender(null, null, { State: 1 }).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }

                setLoading(false);
            }
        );
    }

    const agregarItem = () => {
        let b = {
            State: 1,
            IDBusinessProcess: undefined,
            IDContractRole: undefined,
            InitProps: '{}',
            IsPublic: false
        }
        setBean(b);
        setModal({ ...modal, 'view': true });
    }

    const eliminarItem = () => {
        bean.State = 2;
        updateItem();
        setModalConfirm({ ...modalConfirm, 'view': false });
    }
    const updateItem = () => {
        setModal({ ...modal, 'view': false });
        setLoading(true);
        Service.updateRequestTypeBpm(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                _single.update(bean);
            });

    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: true, evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            { titulo: 'Iniciar Proceso', icono: 'ri-mail-check-line', visible: true, evento: () => { setModalStart({ ...modalStart, "view": true }) } },
            { titulo: 'Configurar Usuarios', icono: 'ri-team-line', visible: !bean.IsPublic, evento: () => { setModalUsers({ ...modalUsers, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const startProcess = () => {
        _bProcess.instance.requestBusinessProcess(_single.getAccountID(), response.Obs, bean.CodeProcess, response.VarName, response.VarValue, response.JsonProps, response.ExternalCode).then(
            (resp) => {
                toast.success(`Se ha iniciado el proceso con IDProcedureImp ${resp.IDProcedureImp}`)
                setModalStart({ ...modalStart, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
                toast.success("Se ha iniciado el proceso")
            }
        )
    }

    return (
        <>
            <BasicPage titulo="Flujos de contratos">
                <div className="col-md-12 p-2">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                </div>
            </BasicPage>


            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal} updateModal={setModal} eventModal={total}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Código</label>
                        <input type="text" name="code" className='form-control' value={bean.CodeProcess} onChange={(e) => { setBean({ ...bean, "CodeProcess": e.target.value }) }} />
                    </div>
                    <div className="col-md-6">

                        <SelectorTramites titulo="Clase de tramites" idSelector={bean.IDBusinessClass} onChange={(e) => { setBean({ ...bean, "IDBusinessClass": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectorClaseTramites idProcess={bean.IDBusinessClass} idSelector={bean.IDBusinessProcess} onChange={(e) => { setBean({ ...bean, "IDBusinessProcess": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <ContractRoleSelect idSelector={bean.IDContractRole} onChange={(e) => { setBean({ ...bean, "IDContractRole": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Propiedades de inicializacion</label>
                        <textarea className="form-control" rows={5} value={bean.InitProps} onChange={(e) => { setBean({ ...bean, 'InitProps': e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-12">
                        <BasicSwitch estado={bean.IsPublic} eventChange={(e) => { setBean({ ...bean, "IsPublic": e }) }} label='¿Es Publico?' />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalStart} updateModal={setModalStart} eventModal={() => { startProcess() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>VarName</label>
                        <input type="text" value={response.VarName} className='form-control'
                            onChange={(e) => { setResponse({ ...response, VarName: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>VarValue</label>
                        <input type="number" className='form-control' value={response.VarValue} onChange={(e) => { setResponse({ ...response, VarValue: parseInt(e.target.value) }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Código Externo</label>
                        <input type="text" className='form-control' value={response.ExternalCode} onChange={(e) => { setResponse({ ...response, ExternalCode: e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <JsonFormaterInput value={response.JsonProps} inputType='string' _label='Json Inicializador' returnType='string' onChange={(e) => { setResponse({ ...response, JsonProps: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Observaciones</label>
                        <textarea className="form-control" rows={5} value={response.Obs} onChange={(e) => { setResponse({ ...response, Obs: e.target.value }) }} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalUsers} updateModal={setModalUsers}>
                <RequestTypeBpmAccount requestTypeBPM={bean.IDRequestTypeBpm} />
            </Modal>

        </>
    )
}